import RootLayout from "../../components/layout/RootLayout";
import GetStarted from "./GetStarted";
import Hero from "./Hero";
import Why from "./Why";

const ComputerVision = () => {
  return (
    <RootLayout>
      <main>
        <Hero />
        <Why />
        <GetStarted />
      </main>
    </RootLayout>
  );
};

export default ComputerVision;
